<div class="container">
  <div class="container__photo">
    <img
      class="photo"
      [src]="photo"
      alt="#"
      (click)="onButtonClick()"
    />
  </div>
  <div class="container__caption">
    <h4
      class="caption"
      [innerHTML]="caption"
    ></h4>
  </div>
  <div class="container__summary">
    <p class="summary">{{ summary }}</p>
  </div>
  <div
    class="container__notice-point"
    *ngFor="let point of notice.points"
  >
    <div class="notice-point">
      <img
        class="notice-point__img"
        [src]="point.imgSrc"
        alt="#"
      />
      <p class="notice-point__txt">
        {{ point.caption }}
      </p>
    </div>
  </div>
  <div class="container__footer">
    <div class="footer">
      <div class="footer__button">
        <lib-button
          size="xs"
          (buttonClick)="onButtonClick()"
          [color]="buttonColor"
          >この絵本をつくる</lib-button
        >
      </div>
      <div
        *ngIf="price"
        class="footer__price"
      >
        <lib-price
          [currency]="price.currency"
          [price]="price.value"
          [discount]="discount"
          [vague]="true"
          size="sm"
          spacing="sm"
          type="V"
        ></lib-price>
      </div>
    </div>
  </div>
</div>
